<template>
  <section>
    <SidebarMobile :is-force-mobile="true" />
    <div class="tw-flex tw-w-full tw-h-[95vh] tw-justify-center tw-items-center tw-px-6">
      <div class="tw-flex tw-flex-col tw-gap-16 tablet:tw-gap-20 tw-items-center">
        <img
          class="tw-max-w-[224px] tw-max-h-[64px]"
          :src="$cdn('images/shared/img_stars_horizontal.png')"
          alt="ic_404"
        >
        <div class="tw-flex tw-flex-col tw-gap-8 tablet:tw-gap-16 tw-items-center">
          <!-- Check out our works -->
          <div class="tw-flex tw-flex-col tw-gap-4 tablet:tw-gap-6 tw-items-center">
            <p class="tw-text-h2-semi-bold-mobile tablet:tw-text-h2-semi-bold-desktop">
              Page can't be found.
            </p>
            <span class="tw-text-body-md-mobile tablet:tw-text-body-md-desktop tw-text-center">
              Why not check out
              <a href="/#our-work">some of the projects we've done.</a>
            </span>
          </div>
          <!-- Countdown Button -->
          <button
            class="tw-text-body-md-mobile tablet:tw-text-body-md-desktop tw-text-center tw-border tw-max-w-[168px] tablet:tw-max-w-[222px] tw-px-4 tablet:tw-px-6 tw-py-3 tablet:tw-py-4 tw-rounded-xl"
            @click="toHome"
          >
            Back to home ({{ seconds }}s)
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ref } from 'vue';
import SidebarMobile from '../components/home/sidebar-mobile.vue';

// Timer of 5s to redirect to home page
const seconds = ref(5);

function countDown() {
  if (seconds.value > 0) {
    setTimeout(() => {
      seconds.value--;
      countDown();
    }, 1000);
  } else {
    // Back to home
    toHome();
  }
}

function toHome() {
  window.location.href = '/';
}

export default {
  name: 'page404',
  components: {
    SidebarMobile,
  },
  setup() {
    return {
      seconds,
      toHome,
    };
  },
  mounted() {
    countDown();
  },
};
</script>
